import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CrudService } from '.';
import { SharedFunctions } from '../../../../src/app/shared/shared.functions';
import { GastoAdjuntoPublicoQrResponseDto, GenericResponse, Persona } from '../model';

@Injectable({
  providedIn: 'root'
})
export class SeguridadService extends CrudService<any, number, any, any> { 

  constructor(protected _http: HttpClient, protected sharedFunctions: SharedFunctions) {
    super(_http,'seguridad', sharedFunctions);
  }

  login(p: any): Observable<any> {
    return this._http.post<any>(this._serviceUrl + '/login', p, this.httpOptions);
  }

  registerAdmin(p: any): Observable<any> {
    return this._http.post<any>(this._serviceUrl + '/admin/register', p, this.httpOptions);
  }

  registerUser(p: any): Observable<any> {
    return this._http.post<any>(this._serviceUrl + '/user/register', p, this.httpOptions);
  }

  forgotUser(p: any): Observable<any> {
    return this._http.post<any>(this._serviceUrl + '/forgot-user', p, this.httpOptions);
  }

  forgotPassword(p: any): Observable<any> {
    return this._http.post<any>(this._serviceUrl + '/reset-password', p, this.httpOptions);
  }

  saveResetPassword(p: any): Observable<any> {
    return this._http.post<any>(this._serviceUrl + '/save-reset-password', p, this.httpOptions);
  }

  checkUsuarioPermiso(funcion:string): Observable<boolean> {
    return this._http.get<boolean>(this._serviceUrl + '/check-usuario-permiso/' + funcion, this.httpOptions);
  }

  processNewUserToken(p: string): Observable<GenericResponse<any>> {
    return this._http.post<GenericResponse<any>>(this._serviceUrl + '/process-token-new-user', { Token: encodeURI(p) }, this.httpOptions);
  }
  
  processExpenseToken(p: string): Observable<GenericResponse<GastoAdjuntoPublicoQrResponseDto>> {
    return this._http.post<GenericResponse<GastoAdjuntoPublicoQrResponseDto>>(this._serviceUrl + '/process-token-expenses', { Token: encodeURI(p) }, this.httpOptions);
  }
}